<br/><br/><br/><br/>

    <div style="display:Table; text-align: center; margin-left:auto; margin-right:auto;">
      <div style="display: Table-row">
        <div style="display: Table-cell" >
            <p>
                <i>Play an MP3 File. </i>
                </p>
          <div style="color:white;font-weight:700;">Last Event: <span  style="color:#992932; font-weight:700;">{{_LastEvent}}</span></div>
          <htmlAudio [src]="'/assets/audio.mp3/Breakfast.Club.Karla.Devito.We.Are.Not.Alone.mp3'" [controls]="true" [preload]="'auto'" (register)="Registered($event)" (audioEvents)="AudioEvents($event)" [autoPlay]="true"></htmlAudio>
        </div>
      </div>
    </div>  
<div [style.background]="'url(./../../../../assets/images.background/BenFranklin.DoThingWorthDoing.png)'" [style.background-size]="'cover'" style="position: fixed; right: 0; bottom: 0; z-index: -100; width: auto; height: auto; background-repeat: no-repeat; background-size: cover; min-height: 100%; min-width: 100%;"></div>